import { connect } from 'react-redux';
import { episodePlayerStart } from 'store/playerPodCast/playerPodCast.actions';
import {
  podcastHeartStart,
  removeFavoritePodcastStart
} from 'store/userHistoryPodcast/userHistoryPodcast.actions';
import { showSnackbarNotification } from 'store/notification/notification.actions';
import {
  setCurrentPodcastid,
  setPodcastQueue
} from 'store/podcastPlaylist/podcastPlaylist.actions';

const mapStateToProps = (state) => ({
  podcastState: state.podcast,
  playerPodCastState: state.playerPodCast,
  userHistoryPodcastState: state.userhistoryPodcast,
  podcastPlaylistState: state.podcastPlaylist
});

const mapDispatchToProps = (dispatch) => ({
  onEpisodePlayerStart: (podcastid, episodeid) =>
    dispatch(episodePlayerStart(podcastid, episodeid)),
  onFavouritePodcast: (id) => dispatch(podcastHeartStart(id)),
  onRemoveFavoritePodcastStart: (id) =>
    dispatch(removeFavoritePodcastStart(id)),
  onSetCurrentPodcastid: (podcastid) =>
    dispatch(setCurrentPodcastid(podcastid)),
  onSetPodcastQueue: (podcastid, episodeid) =>
    dispatch(setPodcastQueue(podcastid, episodeid)),
  onShowSnackbarNotification: (message) =>
    dispatch(showSnackbarNotification(message))
});

const container = connect(mapStateToProps, mapDispatchToProps);

export default container;
